import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import tokens from '../theme/tokens';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// Gráfico de barras com a paleta da marca. `series`: [{ label, data, color }]
const BarChart = ({ labels, series, height = 260, stacked = false }) => {
  const data = {
    labels,
    datasets: series.map((s, index) => ({
      label: s.label,
      data: s.data,
      backgroundColor: s.color || [tokens.color.brand, tokens.color.inkSoft, tokens.color.gold][index % 3],
      borderRadius: 6,
      maxBarThickness: 36,
    })),
  };
  const options = {
    maintainAspectRatio: false,
    plugins: { legend: { display: series.length > 1, position: 'bottom', labels: { usePointStyle: true, boxWidth: 8 } } },
    scales: {
      x: { stacked, grid: { display: false } },
      y: { stacked, beginAtZero: true, ticks: { precision: 0 }, grid: { color: tokens.color.border } },
    },
  };
  return (
    <div style={{ height }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
